import { copReasonCodes } from '../../config';
import { RESET_APP } from '../../states/page/actions';
import { GO_TO_COP_PAGE, SET_COP_DETAILS, SUBMIT_COP_CHECK_SUCCESS, SET_COP_BENEFICIARY } from './actions';
import { getReasonCode } from './selectors';

const actionHandlers = {
	[RESET_APP]: () => ({}),
	[SET_COP_DETAILS]: (state, action) => ({
		...state,
		...action.copDetails,
	}),
	[SUBMIT_COP_CHECK_SUCCESS]: (state, action) => {
		const reasonCode = getReasonCode(state);
		if (reasonCode === copReasonCodes.noMatch.ERR1) {
			return { ...state, result: action.payload };
		}

		return { ...state, result: action.payload };
	},
	[GO_TO_COP_PAGE]: (state, action) => ({ ...state, page: action.page }),
	[SET_COP_BENEFICIARY]: (state, action) => ({ ...state, beneficiaryId: action.payload.id }),
};

const cop = (state = {}, action) => (actionHandlers[action.type] || ((s) => s))(state, action);

export default cop;
